import Spinner from 'react-bootstrap/Spinner';

const Loading = () => {
    return (
        <>
            <Spinner animation="border" variant="success" className='spinner' />
        </>
    )
}
export default Loading